import React from 'react'
import './FooterPageCSS.css'
import { FaFacebookF, FaTwitter, FaPinterest, FaYoutube, FaInstagram, FaLinkedin } from 'react-icons/fa'

const FooterPage = () => {
  return (
    <footer className="footer-section1">
      <div className="footer-container1">
        {/* Left */}
        <div className="footer-column">
          <h2>MANIKBAG DIGAMBAR JAIN BOARDING</h2>
          <p>A Matrimonial Brand by TechnoAarv.<br />
            India’s Trusted Community Matrimony Platform</p>
          <p>✅ Verified Profiles 🟩 Easy Search 🟩 Secure Matchmaking</p>
          <p>✅ 100% Genuine Members 🟩 Trusted Contact Sharing</p>
          <p>ISO 9001:2015 Certified Matrimonial Company</p>
          <p>No Fake Profiles. No Dating. Only Real Marriages.</p>
        </div>

        {/* Center - Menus */}
        <div className="footer-column">
          <h4>MAIN MENU</h4>
          <ul>
            <li>About Us</li>
            <li>Media</li>
            <li>Happy Stories</li>
            <li>Blogs</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>USEFUL LINKS</h4>
          <ul>
            <li>Terms & Conditions</li>
            <li>Privacy Policy</li>
            <li>Sitemap</li>
            <li>FAQ</li>
            <li>Help</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* Right */}
        {/* <div className="footer-column">
          <h4>APP AVAILABLE ON</h4>
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/512px-Google_Play_Store_badge_EN.svg.png" alt="Google Play" className="google-play-img" />
          <div className="social-icons">
            <FaFacebookF />
            <FaTwitter />
            <FaPinterest />
            <FaYoutube />
            <FaInstagram />
            <FaLinkedin />
          </div>
          <div className="customer-count">
            <p>HAPPY CUSTOMERS</p>
            <div className="counter-box">000042439</div>
          </div>
        </div> */}

      </div>
    </footer>
  )
}

export default FooterPage
